import { useBookingContext } from '../BookingContext'
import { Card, CardContent } from '@w/components/ui/card'
import { Button } from '@w/components/ui/button'
import { Badge } from '@w/components/ui/badge'
import { Check, Clock, DollarSign, RefreshCcw } from 'lucide-react'

export default function ServiceCard() {
  const { selectedService, services, changeService } = useBookingContext()

  if (!selectedService) return null

  // Format duration
  const hours = Math.floor(selectedService.base_duration / 60)
  const minutes = selectedService.base_duration % 60
  const durationText = `${hours}h${minutes > 0 ? ` ${minutes}m` : ''}`

  // Format price
  let priceText = ''
  if (selectedService.base_price) {
    priceText = selectedService.base_price
  }

  const canChangeService = services.length > 1

  return (
    <Card className="border-none shadow-none">
      <CardContent className="p-6">
        <div className="flex justify-between items-start mb-6">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
              <Check className="w-5 h-5 text-white" />
            </div>
            <div>
              <h3 className="font-semibold text-xl">Selected Service</h3>
              <p className="text-xs text-muted-foreground">Your chosen service</p>
            </div>
          </div>
          {canChangeService && (
            <Button variant="ghost" size="sm" onClick={changeService} className="gap-2">
              <RefreshCcw className="w-4 h-4" />
              Change
            </Button>
          )}
        </div>

        <Card className="border-2 border-primary/20 bg-primary/5 shadow-sm">
          <CardContent className="p-5 flex gap-4">
            {/* Icon */}
            <div
              className="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0"
              style={{
                backgroundColor: selectedService.color_code
                  ? `${selectedService.color_code}15`
                  : 'rgba(59, 130, 246, 0.1)',
              }}
            >
              <svg
                className="w-7 h-7"
                style={{ color: selectedService.color_code || '#3b82f6' }}
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                />
              </svg>
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0">
              <h4 className="font-semibold text-lg mb-2 text-foreground">
                {selectedService.name}
              </h4>
              {selectedService.description && (
                <p className="text-sm text-muted-foreground mb-3 leading-relaxed">
                  {selectedService.description}
                </p>
              )}
              <div className="flex gap-3 flex-wrap">
                <Badge variant="secondary" className="flex items-center gap-1">
                  <Clock className="w-3 h-3" />
                  {durationText}
                </Badge>
                {priceText && (
                  <Badge variant="outline" className="flex items-center gap-1 text-green-600 border-green-200">
                    <DollarSign className="w-3 h-3" />
                    From ${priceText}
                  </Badge>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      </CardContent>
    </Card>
  )
}
